
















import { Component, Vue, Prop } from 'vue-property-decorator'
import SettingsCard from '@/components/WorkspaceSettings/SettingsCard.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import api from '@/api'

@Component({
  name: 'LogoUpload',
  components: { AjaxButton, SettingsCard }
})

export default class LogoUpload extends Vue {
  @Prop({ required: false }) logo!: string| null

  icon:string| null = this.logo
  processing: boolean = false

  get uploadButtonText () {
    return this.logo ? 'Change' : 'Upload'
  }

  get imageUrl () {
    return this.processing ? '/img/plain-loader.gif' : this.logo
  }

  selectFile ($event: any) {
    $event.finish()

    const ref = this.$refs.realUpload as HTMLInputElement
    ref.click()
  }

  async uploadFile (file: File) {
    const key = (Math.random().toString(36) + '00000000000000000').slice(2, 16) + '_' + file.name.replace(/[^A-Z0-9.]+/ig, '_')
    const response = await api.uploadFile(file, key)
    if (response.status !== 200) {
      throw new Error(`Error uploading workspace logo: ${response.statusText}`)
    }
    return response.config.url
  }

  handleUpload ($event: Event) {
    if (!$event) return
    const files = ($event.target as HTMLInputElement).files
    const asset = files && files[0]

    if (!asset) {
      console.error('No file provided to upload')
    } else {
      this.processing = true
      this.uploadFile(asset)
        .then((url) => {
          this.processing = false
          this.$emit('change', url)
        })
        .catch(err => console.error('Logo Upload Error', err)) // TODO: Show an actual error.
    }
  }
}
